<div class="status-label__container" [style.background-color]="color">
  @if (!isFixed) {
    <div class="status-label__modifiable-wrapper">
      <span>{{ text | uppercase }}</span>
      <mat-icon class="pointer" [matMenuTriggerFor]="statusMenu">expand_more</mat-icon>
    </div>
  } @else {
    <div class="status-label__unmodifiable-wrapper">{{ text | uppercase }}</div>
  }
</div>

<mat-menu #statusMenu yPosition="below" xPosition="before" class="status-label__menu">
  @for (menuItem of statuses; track menuItem) {
    <button
      mat-menu-item
      class="status-label__menu-button"
      [disabled]="status === menuItem.id"
      (click)="onStatusChange(menuItem.id)"
    >
      <div class="status-label__menu-button-content-container">
        <div
          class="status-label__menu-button-circle"
          [style.background-color]="menuItem.color"
        ></div>
        <span [ngClass]="{ bold: status === menuItem.id }">{{ menuItem.text }}</span>
      </div>
    </button>
  }
</mat-menu>
